import { useContext, useEffect, useState } from "react";
import "./Css/blog.css";
import Next from "./assets/images/next.svg";
import Previous from "./assets/images/previous.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AppContext } from "../../context/AppContext";

const Blog = () => {
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 6;
  const navigate = useNavigate();

  // Blog get state
  const [blogData, setBlogData] = useState([]);
  const { baseUrl, Backend_folder_path, setblogid } = useContext(AppContext);
  const adminurl = "http://localhost:4000/api";

  useEffect(() => {
    axios
      .get(`${baseUrl}/get-blog`)
      .then((res) => {
        const titleTag = document.querySelector("head > title");
        titleTag.textContent = "Blog";
        setBlogData(res.data.getAllBlog);
      })
      .catch((err) => console.error("API error:", err));
  }, []);

  //console.log("blogData", blogData);

  // Filter posts where blogStatus is true
  const activePosts = blogData.filter((post) => post.blogStatus === true);

  // Pagination calculations
  const totalPosts = activePosts.length;
  const totalPages = Math.ceil(totalPosts / postsPerPage);
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = activePosts.slice(indexOfFirstPost, indexOfLastPost);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      // Scroll to top when page changes
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  // Generate page numbers for pagination
  const getPageNumbers = () => {
    const pageNumbers = [];
    const maxVisiblePages = 5;

    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    return pageNumbers;
  };

  // Handle blog post click - Navigate to detail page
  const handlePostClick = (postId, url_key) => {
    setblogid(postId);
    const titleTag = document.querySelector("head > title");
    titleTag.textContent = url_key;
    navigate(`/blog/${url_key}`);
  };

  return (
    <div className="blog-container">
      {/* Blog Posts Grid */}
      <div className="blog-content">
        <div className="container">
          <div className="blog-grid">
            {currentPosts.length > 0 ? (
              currentPosts.map((post) => (
                <article key={post.id} className="blog-card">
                  {/* Image */}
                  <div className="blog-image">
                    <img
                      src={`${Backend_folder_path}${post.imagePath}`}
                      alt={post.title}
                    />
                    <div className="category-badge">{post.categoryType}</div>
                  </div>

                  {/* Content */}
                  <div className="blog-card-content">
                    <h2>{post.title}</h2>
                    <p
                      className="description"
                      dangerouslySetInnerHTML={{ __html: post.description }}
                    />
                    {/* Meta information */}
                    <div className="blog-meta">
                      <div className="meta-left">
                        <span className="author">{post.authorName}</span>
                        <span className="date">
                          {new Date(post.createdAt).toLocaleDateString(
                            "en-US",
                            {
                              month: "short",
                              day: "numeric",
                              year: "numeric",
                            }
                          )}
                        </span>
                      </div>
                      <span className="read-time">{post.readTime}</span>
                    </div>
                    {/* Read more button */}
                    <div
                      className="read-more"
                      onClick={() => handlePostClick(post.id, post.url_key)}
                    >
                      Read More
                    </div>
                  </div>
                </article>
              ))
            ) : (
              <div className="no-posts">No active blog posts available.</div>
            )}
          </div>

          {/* Pagination - Only show if there are multiple pages */}
          {totalPages > 1 && (
            <div className="pagination-container">
              <div className="pagination">
                {/* Previous button */}
                <button
                  className={`pagination-btn ${
                    currentPage === 1 ? "disabled" : ""
                  }`}
                  onClick={() => handlePageChange(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  <img src={Previous} alt="previous" />
                </button>

                {/* Page numbers */}
                {getPageNumbers().map((number) => (
                  <button
                    key={number}
                    className={`pagination-btn page-number ${
                      currentPage === number ? "active" : ""
                    }`}
                    onClick={() => handlePageChange(number)}
                  >
                    {number}
                  </button>
                ))}

                {/* Next button */}
                <button
                  className={`pagination-btn ${
                    currentPage === totalPages ? "disabled" : ""
                  }`}
                  onClick={() => handlePageChange(currentPage + 1)}
                  disabled={currentPage === totalPages}
                >
                  <img src={Next} alt="next" />
                </button>
              </div>

              {/* Page info */}
              <div className="page-info">
                Showing {indexOfFirstPost + 1}-
                {Math.min(indexOfLastPost, totalPosts)} of {totalPosts} posts
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Blog;
